import styles from './style.module.scss';

export const CHAT_BUTTON_GRAY = 'grayButton';
export const CHAT_BUTTON_PURPLE = 'purpleButton';
export const CHAT_BUTTON_PURPLE_SECONDARY = 'purpleButtonSecondary';
export const CHAT_BUTTON_PURPLE_WITH_ICON = 'purpleChatBtnWithIcon';
export const CHAT_BUTTON_SECONDARY_WITH_ICON = 'purpleChatBtnSecondaryWithIcon';
export const CHAT_TEXT_LINK = 'textLink';
export const CHAT_WHITE_LINK = 'whiteLink';
export const CHAT_BLACK_LINK = 'blackLink';

export const SEND_MESSAGE_ANALYTICS = 'Send message';

export const CHAT_STYLE_MAP = new Map([
  [CHAT_BUTTON_GRAY, styles.grayChatBtn],
  [CHAT_BUTTON_PURPLE, styles.purpleChatBtn],
  [CHAT_BUTTON_PURPLE_SECONDARY, styles.purpleSecondaryChatBtn],
  [CHAT_BUTTON_PURPLE_WITH_ICON, styles.purpleChatBtnWithIcon],
  [CHAT_BUTTON_SECONDARY_WITH_ICON, styles.secondaryChatBtnWithIcon],
  [CHAT_TEXT_LINK, styles.textLink],
  [CHAT_WHITE_LINK, styles.whiteLink],
  [CHAT_BLACK_LINK, styles.blackLink],
]);
